// extracted by mini-css-extract-plugin
export default {"bodyWrapper":"bodyWrapper-J_9Mc","button":"button-IzWkv"};